import React from 'react';
import { Box } from '@chakra-ui/react';
import { FormControl } from 'src/components/UI/FormControl';
import { PasswordWithValidation } from 'src/components/UI/Input/PasswordWithValidation';
import { MASKS } from 'src/components/UI/Input/MaskedInput';
import MevoInput from 'src/components/Input';
import Typography from 'src/components/Typography';

interface AccessDataFieldsProps {
  cellphoneNumber: string;
  email: string;
  password: string;
  cellphoneNumberError?: string;
  emailError?: string;
  passwordError?: string;
  onCellphoneNumberChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onEmailChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onPasswordChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onCellphoneNumberBlur: () => void;
  onEmailBlur: () => void;
  onPasswordBlur: () => void;
  onPasswordValidationChange: (isValid: boolean) => void;
  isLoadingPhoneNumber?: boolean;
}

export function AccessDataFields({
  cellphoneNumber,
  email,
  password,
  cellphoneNumberError,
  emailError,
  passwordError,
  onCellphoneNumberChange,
  onEmailChange,
  onPasswordChange,
  onCellphoneNumberBlur,
  onEmailBlur,
  onPasswordBlur,
  onPasswordValidationChange,
  isLoadingPhoneNumber = false,
}: AccessDataFieldsProps) {
  return (
    <>
      <Box mb="20px">
        <Typography model="body" size="large" weight="bold">
          Dados de acesso
        </Typography>
      </Box>

      <FormControl isInvalid={!!cellphoneNumberError} mb="20px">
        <MevoInput
          id="cellphoneNumber"
          labelText="CELULAR*"
          type="tel"
          h="45px"
          placeholderText="(99) 9 9999-9999"
          name="cellphoneNumber"
          value={cellphoneNumber}
          onChange={onCellphoneNumberChange}
          onBlur={onCellphoneNumberBlur}
          errorText={cellphoneNumberError}
          mask={MASKS.BRAZIL_PHONE}
          autoFocus={!isLoadingPhoneNumber}
          autoComplete="tel-country-code"
          disabled={isLoadingPhoneNumber}
          isLoading={isLoadingPhoneNumber}
        />
      </FormControl>

      <FormControl isInvalid={!!emailError} mb="20px">
        <MevoInput
          id="email"
          labelText="EMAIL*"
          h="45px"
          placeholderText="Digite seu email aqui"
          name="email"
          type="email"
          value={email}
          onChange={onEmailChange}
          onBlur={onEmailBlur}
          errorText={emailError}
        />
      </FormControl>

      <Box mb="20px">
        <PasswordWithValidation
          label="SENHA*"
          value={password}
          onChange={onPasswordChange}
          onBlur={onPasswordBlur}
          onValidationChange={onPasswordValidationChange}
          errorMessage={passwordError}
          isInvalid={!!passwordError}
          name="password"
          placeholder="Digite aqui a senha"
        />
      </Box>
    </>
  );
}
